import React from "react";
import { useComponentRegistry } from "../../../componentRegistry";

type Props = {
    onClick?: () => void;
};

const PdpUscPersonaliseFinanceButton = ({ onClick }: Props): JSX.Element | null => {
    const UscPersonaliseFinanceButton = useComponentRegistry("UscPersonaliseFinanceButton");

    return <UscPersonaliseFinanceButton onClick={onClick} />;
};

export default PdpUscPersonaliseFinanceButton;
